import React from 'react';
import { Footer } from '@is24at/footer';
import Header from 'components/Header';
import HtmlMeta from 'components/HtmlMeta';
import styles from './MainLayout.scss';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => (
  <div className={styles['main-layout']}>
    <HtmlMeta />
    <Header />
    <main className={styles.main}>{children}</main>
    <Footer />
  </div>
);

export default MainLayout;
